module.exports = __webpack_public_path__ + "static/media/onas-obrazok.26104636.png";